import type { ExecutionCommentList, ExecutionCommentView } from '@testflow/shared';
import { request } from './api.js';

// #193: Kommentare zur Ausführung — Anker ist Plan + Testfall, nicht der Lauf.
const path = (p: string, planId: string, testCaseId: string) =>
  `/v1/projects/${p}/plans/${planId}/testcases/${testCaseId}/comments`;

// Der Schlüssel steht hier neben der Api, weil ihn zwei Stellen brauchen: die Liste im
// Ausführungsfeld und (Lauf-Historie) die Anzeige derselben Kommentare. Das Präfix
// `['execution-comments', p, planId]` invalidiert alle Testfälle eines Plans auf einmal — so
// wandern die Kommentare nach einem Lauf in „Aus vorherigen Testläufen".
export const executionCommentsKey = (p: string, planId: string, testCaseId: string) =>
  ['execution-comments', p, planId, testCaseId] as const;

export const executionCommentsApi = {
  list: (p: string, planId: string, testCaseId: string) =>
    request<ExecutionCommentList>(path(p, planId, testCaseId)),
  create: (p: string, planId: string, testCaseId: string, body: string) =>
    request<ExecutionCommentView>(path(p, planId, testCaseId), {
      method: 'POST',
      body: JSON.stringify({ body }),
    }),
  update: (p: string, planId: string, testCaseId: string, commentId: string, body: string) =>
    request<ExecutionCommentView>(`${path(p, planId, testCaseId)}/${commentId}`, {
      method: 'PATCH',
      body: JSON.stringify({ body }),
    }),
  remove: (p: string, planId: string, testCaseId: string, commentId: string) =>
    request<void>(`${path(p, planId, testCaseId)}/${commentId}`, { method: 'DELETE' }),
};
